export interface LoginParams {
  username: string;
  password: string;
}

export enum ThemesEnum {
  LIGHT = 'light',
  DARK = 'dark'
}
